import _ from 'lodash'
import React, { Component, PropTypes } from 'react'
import { withRouter } from 'react-router'
import { redirectAbsolutePath } from 'utils/redirect'
import { getEventUrl } from 'utils/urls'
import { formatPriceDecimals } from 'utils/format'

import EventHeader from './event-header'

export class EventHeaderContainer extends Component {

  constructor(props) {
    super(props)

    this.handleAddEventClick = this.handleAddEventClick.bind(this)
    this.handleBackClick = this.handleBackClick.bind(this)
    this.handleDetailsClick = this.handleDetailsClick.bind(this)
    this.handleIntegrationClick = this.handleIntegrationClick.bind(this)
    this.handleViewUrlClick = this.handleViewUrlClick.bind(this)
    this.handleEditClick = this.handleEditClick.bind(this)
  }

  handleAddEventClick() {
    redirectAbsolutePath(this.props.addNewDatesUrl)
  }

  handleEditClick() {
    this.props.router.push(getEventUrl(this.props.partnerId, this.props.eventGroupId, '/grid'))
  }

  handleBackClick() {
    this.props.router.push(getEventUrl(this.props.partnerId, this.props.eventGroupId))
  }

  handleDetailsClick() {
    this.props.router.push(getEventUrl(this.props.partnerId, this.props.eventGroupId, '/details'))
  }

  handleIntegrationClick() {
    this.props.router.push(getEventUrl(this.props.partnerId, this.props.eventGroupId, '/integrations'))
  }

  handleViewUrlClick() {
    window.open(this.props.whitelabelUrl, '_blank')
  }

  render() {
    const { totalPartnerShare, currencyCode, addNewDatesUrl } = this.props
    const formattedPartnerShare = formatPriceDecimals(totalPartnerShare, currencyCode)

    return (
      <EventHeader
        {...this.props}
        totalPartnerShare={_.isNil(totalPartnerShare) ? null : formattedPartnerShare}
        onAddEventClick={addNewDatesUrl ? this.handleAddEventClick : null}
        onEditClick={this.handleEditClick}
        onBackClick={this.handleBackClick}
        onDetailsClick={this.handleDetailsClick}
        onIntegrationClick={this.handleIntegrationClick}
        onViewUrlClick={this.handleViewUrlClick}
      />
    )
  }
}

EventHeaderContainer.propTypes = {
  addNewDatesUrl: PropTypes.string,
  currencyCode: PropTypes.string,
  eventGroupId: PropTypes.any,
  isRoot: PropTypes.bool,
  partnerId: PropTypes.any,
  router: PropTypes.object,
  showSummaryLink: PropTypes.bool,
  showEditLink: PropTypes.bool,
  soldTickets: PropTypes.any,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  totalPartnerShare: PropTypes.any,
  whitelabelUrl: PropTypes.string,
}

export default withRouter(EventHeaderContainer)



/** WEBPACK FOOTER **
 ** ./src/components/event-header/event-header-container.js
 **/